import { STORAGE_KEYS } from '@coligo-org/fe-common/constants';

export const storeMeQrData = ({ qrToken }) => {
  if (!qrToken) return;
  const { _id, userId, token, username } = qrToken;

  const formattedValue = `${_id};${userId};${token};${username}`;
  localStorage.setItem(STORAGE_KEYS.QR_TOKEN, formattedValue);
};
